import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
// Service
import { BroadcastService, ToasterType } from '@cv-invision/core';
import { OrderInboxService } from '../../inbox/service/order-inbox.service';
// Other

@Component({ template: '' })
export class UCDPOverrideComponent implements OnInit {
	public orderId;
	public documentId;
	public form = new FormGroup({
		CUScore: new FormControl(null, [Validators.min(0)]),
		LPAScore: new FormControl(null, [Validators.min(0)]),
		UCDPDocFileId: new FormControl(null, Validators.pattern('[\\w\\-_ ]*')),
		EADDocFileId: new FormControl(null, Validators.pattern('[\\w\\-_ ]*')),
	});
	public files = {
		SSR_FNMA_Document: {
			errorMessage: '',
			blob: null,
		},
		SSR_FREDDIE_Document: {
			errorMessage: '',
			blob: null,
		},
		SSR_FHA_Document: {
			errorMessage: '',
			blob: null,
		},
	};

	public ssrDocuments = [
		{ title: 'FNMA', type: 'SSR_FNMA_Document' },
		{ title: 'FREDDIE', type: 'SSR_FREDDIE_Document' },
		{ title: 'FHA', type: 'SSR_FHA_Document' },
	];

	get isThereFilesToUpload(): boolean {
		let response = false;

		Object.keys(this.files).forEach((key) => {
			if (this.files[key].blob !== null) {
				response = true;
			}
		});

		return response;
	}

	constructor(
		protected inboxService: OrderInboxService,
		protected broadcastService: BroadcastService,
		protected dialogRef: DynamicDialogRef,
		protected dialogConfig: DynamicDialogConfig
	) {}

	ngOnInit() {
		this.loadCUDependencies();
	}

	/**
	 * Loads the CU dependency data
	 */
	loadCUDependencies() {
		if (this.dialogConfig?.data?.orderId && this.dialogConfig?.data?.documentId) {
			this.orderId = this.dialogConfig.data.orderId;
			this.documentId = this.dialogConfig.data.documentId;
		}
	}

	close() {
		this.dialogRef.close({ reloadFindings: true });
	}

	/**
	 * Saves the new cuscore of the selected order.
	 */
	public save() {
		if (this.orderId && this.documentId && this.form.valid) {
			const payload = {
				orderId: this.orderId,
				documentId: this.documentId,
				form: this.form.value,
				files: this.files,
			};

			this.inboxService.overwriteCUScoreV2(payload).subscribe((response) => {
				this.broadcastService.broadcast({
					name: ToasterType.SUCCESS,
					event: {
						message:
							response?.message ??
							`The details for this order <span class="order-id">${this.orderId} </span> has been successfully overwritten.`,
					},
				});
				this.dialogRef.close({ reloadData: true });
			});
		}
	}

	/**
	 * Get the latest file Uploaded
	 * @param files
	 * @param type
	 */
	public onFilesDropped(files: File[], type: string): void {
		this.files[type].errorMessage = '';
		this.files[type].blob = null;

		if (files.length > 1) {
			files.shift();
		}

		if (files.length) {
			const selectedFile = files[0];
			const isPDF =
				selectedFile.type === 'application/pdf' ||
				selectedFile.type === 'text/pdf' ||
				selectedFile.name.endsWith('.pdf');

			if (!isPDF) {
				this.files[type].errorMessage = 'Only PDF files can be uploaded. Please try again.';
			} else {
				this.files[type].errorMessage = '';
				this.files[type].blob = selectedFile;
			}
		}
	}
}
